import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import accredhospilogo from '../../assets/images/accredhospi-logo.png'
import { connect } from 'react-redux';
import { SET_REFERENTIEL, SET_INFOS } from '../../state/action/action';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
		maxWidth: 400,
  },
  gridMain: {
    display: 'flex',
		flexDirection: 'column',
    alignItems: 'center',
		justifyItems: 'center',
  },
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none'
      }
  }
}));


function Home({referentiel, dispatch}) {
	// state
	const classes = useStyles()

	useEffect(() => {
		fetchJson();
	}, [])
	
	const setReferentiel = (value) => {
		//if( referentiel == null) {
			const action = {
				type: SET_REFERENTIEL,
				value
			};
			dispatch(action)
		//}
	}

	const fetchJson = async () => {
		try {
			const jsonFile = await fetch('./data/domaine/management/referentiel.json');
			const res = await jsonFile.json();

			const cloneRef = JSON.parse(JSON.stringify(res));
			setReferentiel(cloneRef)

			//console.log(referentiel)
		} catch (err) {
			console.log(`Err: ${err}`);
		}
	}


  return (
	<div className={classes.root}>
		<Grid container direction='column' alignItems='center' justify='center'>
			<Typography align='center'  >
				Bienvenue sur AccredHospi-Benin, Plateforme béninoise pour l’accréditation des Hôpitaux
			</Typography>
			<Grid container item direction='column' alignItems='center' justify='center' style={{width: '350px', height: '350px',}} >
				<img src={accredhospilogo} alt='Logo AccredHospi' style={{width: '334px', height: '279px'}} />
			</Grid>
		</Grid>
		<Grid container item  className={classes.gridMain} spacing={3}>
			<Typography align='justify'>
				Cette plateforme est basée sur le manuel d’accréditation hospitalière au Bénin. Elle peut être utilisée aussi bien  pour un audit interne qu’une évaluation externe.
			</Typography>
			<Typography align='justify'>
				Pour continuer cliquez sur renseignements pour nous donner vos informations générales et débuter une évaluation ou cliquez sur le menu pour  choisir où aller
			</Typography>
			
			<Link to='/infos' style={{ textDecoration: 'none', color: 'inherit', marginTop: '5%', marginBottom: '15%' }}>
				<Button variant="outlined" color="primary" className={classes.btn}>
					Renseignements
				</Button>
			</Link>
		</Grid>
	</div>
	)
}

const mapStateToProps = (state) => {
	return {
		referentiel: state.setReferentielReducer.referentiel,
		information: state.setInfosReducer.infos
	}
}

export default connect(mapStateToProps)(Home);
